(function ($) {
    var headerControler = $('.expert-v12-header-scroll-control-js');
    var headerContainer = $('.header-expert-js');
    var ishome = $('.top_hero').length;
    var isHeaderBlack = $('.expert-header-black-js').length;
    if (headerControler.length) {
        $(window).on('scroll', function () {
            if (!isHeaderBlack) {
                var scrollTop = $(window).scrollTop(),
                    elementOffset = headerControler.offset().top,
                    distance = (elementOffset - scrollTop),
                    stickyActiveAt = ishome ? -1 * $('.background__top_hero').height() : -1 * $('.background').height();
                if (distance < stickyActiveAt) {
                    headerContainer.addClass('header-scroll');
                } else {
                    headerContainer.removeClass('header-scroll');
                }
            } else {
                var scrollTop = $(window).scrollTop();
                var stickyAt = window.innerWidth > 1180 ? 120 : 50;
                if (scrollTop > stickyAt) {
                    headerContainer.addClass('header-scroll');
                } else {
                    headerContainer.removeClass('header-scroll');
                }
            }
        });
    }

    /* Show or hide the "footer-fixed-registration button"
    ======================================================*/
    // the WaitTime Plug-in: Defining a custom scrolled method with setTimeout
    var uniqueCntr = 0;
    $.fn.scrolled = function (waitTime, fn) {
        if (typeof waitTime === "function") {
            fn = waitTime;
            waitTime = 300;
        }
        var tag = "scrollTimer" + uniqueCntr++;
        this.scroll(function () {
            var self = $(this);
            var timer = self.data(tag);
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                self.removeData(tag);
                fn.call(self[0]);
            }, waitTime);
            self.data(tag, timer);
        });
    };

    // Check Position Function
    var fixedFooterBanner = $('.fixed-footer-banner-js');
    var position = 0;
    function checkPosition() {
        var scrollTop = $(this).scrollTop();
        if (scrollTop > position) {
            fixedFooterBanner.css('position', 'fixed').slideUp('300');
        } else {
            fixedFooterBanner.css('position', 'fixed').slideDown('300');
        }
        position = scrollTop;
    }
    $(window).scrolled(checkPosition);
})(jQuery);